import { Injectable, inject } from '@angular/core';
import { Notification, NotificationType } from './notification';
import { NOTIFICATIONS_CONFIG, NotificationsConfig } from './notifications-config';

@Injectable({
  providedIn: 'root',
})
export class NotificationsService {
  private config = inject<NotificationsConfig>(NOTIFICATIONS_CONFIG);

  notifications: Notification[] = [];

  notify(type: NotificationType, message: string, timeout?: number): void {
    this.notifications.push({ type, message });
    setTimeout(() => this.notifications.shift(), timeout ?? this.config.timeout);
  }

  notifyLoading(message: string): void {
    this.notifications.push({ type: NotificationType.LOADING, message });
  }

  stopLoading(message: string): void {
    const index = this.notifications.findIndex(
      ({ message: m, type }) => type === NotificationType.LOADING && m === message,
    );
    if (index !== -1) {
      this.notifications.splice(index, 1);
    }
  }
}
